export function getRootNodeName() {
    return "__root__";
}